import React from 'react';
import { cx } from '@emotion/css';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { BodyLargeEmphasized } from '../Typography';
import styles from './NavBar.styles';
import { AccessibleDivButton } from '@/components';
import { useGoogleTranslator } from '@/hooks';

interface Props {
  children: React.ReactNode;
  onClickCloseButton?: () => void;
  buttonPosition: 'left' | 'right';
  id?: string;
}

export const NavBarCloseButton: React.FC<Props> = ({
  children,
  onClickCloseButton,
  buttonPosition = 'left',
  id,
}) => {
  const titleTranslated =
    typeof children === 'string' ? useGoogleTranslator(children as string) : children;
  return (
    <header className={styles.container} data-testid="navbar">
      <AccessibleDivButton
        className={cx(
          styles.icon,
          buttonPosition === 'left' ? styles.closeButtonLeft : styles.closeButtonRight
        )}
        onClick={onClickCloseButton}
        aria-label="Close"
      >
        <CloseOutlinedIcon role="img" aria-hidden="true" />
        <span className="visually-hidden">Close</span>
      </AccessibleDivButton>
      <BodyLargeEmphasized data-testid="pageName" as="h1" id={id}>
        {titleTranslated}
      </BodyLargeEmphasized>
    </header>
  );
};
